<template>
  <div class="home-page-container">
    <div class="swiper-container">
      <van-swipe :autoplay="10000" indicator-color="#f90">
        <van-swipe-item v-for="(item, index) in images" :key="index">
          <img v-lazy="item.imgUrl" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-notice-bar v-if="bannerInfo.length" left-icon="volume-o" :text="bannerInfo.join('！')" />
    <van-field v-model="fieldValue" is-link readonly label="PK" placeholder="请选择PK对象" @click="onShowPkUser" />
    <van-popup v-model="showPkUser" position="bottom" closeable :style="{ height: '60%' }" @close="onClosePkUser">
      <van-tree-select height="calc(100% - 60px)" :items="userTree" :active-id.sync="activeUserIds"
        :main-active-index.sync="activeL1UserIndex" />
      <div style="height: 60px; display: flex; justify-content: center; align-items: center; padding: 8px;">
        <van-button type="danger" block @click="onConfirmPkUser" :loading="loading">提交</van-button>
      </div>
    </van-popup>
    <div style="width: 100vw; padding: 10px;">
      <canvas id="dataChart"></canvas>
    </div>
  </div>
</template>
<script>
import Chart from 'chart.js/auto'
import { hasOneOf, getRandomColor } from '@/util'
import { fetchUserInfo, getUserList } from '@/services/UserService'
import { getBannerInfo, getSwiperImages } from '@/services/CustomerService'
import { getRecentCommissionData } from '@/services/KpiService'

export default {
  name: 'MobileHome',
  data() {
    return {
      openId: localStorage.getItem('openId'),
      images: [],
      loading: false,
      userInfo: {},
      bannerInfo: [],
      chartData: [],
      fieldValue: '',
      users: [],
      userTree: [],
      showPkUser: false,
      activeUserIds: [],
      selectedUserIds: [],
      activeL1UserIndex: 0
    }
  },
  async mounted() {
    this.$toast.loading({
      duration: 0,
      message: '数据加载中...',
      forbidClick: true
    })
    await this.onInitUserInfo()
    await this.onInitBannerInfo()
    await this.onInitSwiperImages()
    await this.onInitUsers()
    this.onGenerateCUserTree()
    await this.onInitPkUserData()
    this.$toast.clear()
  },
  methods: {
    async onInitUserInfo() {
      const response = await fetchUserInfo({
        openId: this.openId
      })
      this.userInfo = response.data
    },
    async onInitBannerInfo() {
      const response = await getBannerInfo({
        openId: this.openId
      })
      this.bannerInfo = response.data.bannerInfo || []
    },
    async onInitSwiperImages() {
      const response = await getSwiperImages({
        openId: this.openId,
        pageNum: 1,
        pageSize: 20
      })
      this.images = response.data.records || []
    },
    async onInitUsers() {
      const response = await getUserList({
        openId: this.openId,
        pageNum: 1,
        pageSize: 2000
      })
      this.users = ((response.data || {}).records || []).filter(i => i.status === 0)
    },
    async onInitPkUserData() {
      const userIdList = []
      const allCUserIdList = this.users.filter(
        item => item.status === 0 && (item.roleCodeList || []).includes('C') && item.number && item.userId !== this.userInfo.userId
      ).map(item => item.userId)
      if (this.userInfo.roleCodeList.includes('C')) {
        userIdList.push(this.userInfo.userId)
        const randomIndex = Math.floor(Math.random() * (allCUserIdList.length - 1))
        userIdList.push(allCUserIdList[randomIndex])
        this.activeUserIds = [allCUserIdList[randomIndex]]
        this.selectedUserIds = [allCUserIdList[randomIndex]]
      } else {
        const randomIndex1 = Math.floor(Math.random() * (allCUserIdList.length - 1))
        userIdList.push(allCUserIdList[randomIndex1])
        allCUserIdList.splice(randomIndex1, 1)
        const randomIndex2 = Math.floor(Math.random() * (allCUserIdList.length - 1))
        userIdList.push(allCUserIdList[randomIndex2])
        this.activeUserIds = [...userIdList]
        this.selectedUserIds = [...userIdList]
      }
      await this.onGetPkUsersData(userIdList)
    },
    onGenerateCUserTree() {
      const l1Users = this.users.filter(user => hasOneOf(user.roleCodeList || [], 'L1')).map(user => ({
        id: user.userId,
        text: user.name,
        children: []
      }))
      for (let i = 0; i < l1Users.length; i++) {
        this.users.forEach(user => {
          if (user.supervisorIds === l1Users[i].id) {
            if (!user.children) {
              user.children = []
            }
            if (this.userInfo.userId !== user.userId) {
              l1Users[i].children.push({
                id: user.userId,
                text: user.name
              })
            }
          }
        })
      }
      this.userTree = l1Users
    },
    onShowPkUser() {
      this.showPkUser = true
    },
    async onGetPkUsersData(userIdList) {
      const users = this.users.filter(item => userIdList.includes(item.userId))
      this.fieldValue = users.map(item => {
        if (item.userId === this.userInfo.userId) {
          return '我'
        } else {
          return `${item.name}@${item.deptName}`
        }
      }).join('，')
      const response = await getRecentCommissionData({
        openId: this.openId,
        userIdList
      })
      const chartData = []
      const resUserIds = Object.keys(response.data)
      resUserIds.forEach((userId, index) => {
        const user = this.users.find(item => item.userId === userId)
        chartData.push({
          label: user.name,
          data: response.data[userId].map(row => row.count),
          backgroundColor: getRandomColor(),
          borderWidth: 2,
          borderSkipped: false
        })
      })
      if (!this.dataChart) {
        this.dataChart = new Chart(
          document.getElementById('dataChart'),
          {
            type: 'bar',
            data: {
              labels: response.data[resUserIds[0]].map(row => row.date),
              datasets: chartData
            },
            options: {
              aspectRatio: 1,
              indexAxis: 'y'
            }
          }
        )
      } else {
        this.dataChart.data.datasets = chartData
        this.dataChart.update()
      }
    },
    async onConfirmPkUser() {
      this.selectedUserIds = [...this.activeUserIds]
      const userIdList = this.userInfo.roleCodeList.includes('C')
        ? [this.userInfo.userId, ...this.selectedUserIds]
        : [...this.selectedUserIds]
      await this.onGetPkUsersData(userIdList)
      this.showPkUser = false
    },
    onClosePkUser() {
      this.activeUserIds = [...this.selectedUserIds]
    }
  },
  watch: {
    activeUserIds() {
      const userTree = JSON.parse(JSON.stringify(this.userTree))
      userTree.forEach(item => {
        let count = 0
        item.children.forEach(child => {
          if (this.activeUserIds.includes(child.id)) {
            count++
          }
        })
        if (count > 0) {
          item.badge = count
        } else {
          delete item.badge
        }
      })
      this.userTree = userTree
    }
  }
}
</script>
<style lang="less">
.home-page-container {
  height: calc(100vh - 50px);
  background-color: #fff;
  overflow: auto;

  .swiper-container {
    height: 240px;
  }

  .van-swipe-item {
    height: 240px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .van-cell {
    padding-right: 10px;
    padding-left: 10px;

    &::after {
      left: 10px;
      right: 10px;
    }

    .van-field__label {
      width: 20px;
    }
  }

}
</style>
